import { IPublicTicket } from '../../models'

export enum AlterationsTypeKeys {
  SET_ALTERATIONS_MODAL_OPEN = 'SET_ALTERATIONS_MODAL_OPEN',
  SET_DISPLAYED_ACTIVE_TICKETS = 'SET_DISPLAYED_ACTIVE_TICKETS'
}

export interface ISetIsAlterationsModalOpenAction {
  type: typeof AlterationsTypeKeys.SET_ALTERATIONS_MODAL_OPEN
  payload: boolean
  [extraProps: string]: unknown
}

export interface ISetDisplayedActiveTicketsAction {
  type: typeof AlterationsTypeKeys.SET_DISPLAYED_ACTIVE_TICKETS
  payload: IPublicTicket[] | null
  [extraProps: string]: unknown
}

export type AlterationsActionTypes =
  | ISetIsAlterationsModalOpenAction
  | ISetDisplayedActiveTicketsAction
